import designArea from './designArea';

export default {
  template: '#center_control',
  components: {
    designArea,
  },
  data: function() {
    return {
      sides: this.$root.sides,
    };
  },
  methods: {
    unSelectItem: function(e) {
      var topCurso = !document.all ? e.clientY : event.clientY;
      var leftCurso = !document.all ? e.clientX : event.clientX;
      var mouseDownAt = document.elementFromPoint(leftCurso, topCurso);
      if (mouseDownAt.parentNode.className == 'product-design designer-style-front' ||
        mouseDownAt.parentNode.className == 'div-design-area' ||
        mouseDownAt.parentNode.className == 'labView active' ||
        mouseDownAt.parentNode.className == 'content-inner') {
        this.$root.unSelectAllControls();
        this.$root.$set('selectedItem', {});
        e.preventDefault();
      }
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/centerControl.js